import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Vacation } from '../../types/team.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type CreateVacationDto = {
  endDate: string;
  notes?: null | string;
  startDate: string;
  teamMemberId: string;
};

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useCreateVacation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: createVacation, isPending } = useAppMutation([QueryKey.CREATE_VACATION], {
    mutationFn: (body: CreateVacationDto) =>
      ApiService.post<Vacation, CreateVacationDto>(
        { endpoint: BackendRoute.TEAM_VACATIONS },
        { body },
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_VACATIONS] }),
  });

  return { createVacation, isPending };
};
